import styled from 'styled-components';
import { Text, ClearButton, Flexbox } from '@morressier/ts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const LinkButton = styled(ClearButton)`
  color: var(--color-blue-40);
  font-size: var(--fontSizes-normal);
  display: flex;
  align-items: start;
  gap: 4px;
  border-radius: 0.25rem;
  font-weight: var(--fontWeights-semi);
`;

export const Title = styled(Text)`
  font-size: var(--fontSizes-l);
  font-weight: var(--fontWeights-bold);
  line-height: var(--lineHeights-l);
  color: var(--color-mono-0);
`;

export const Description = styled(Text)`
  font-size: var(--fontSizes-normal);
  color: var(--color-mono-40);
`;

export const SparklesIconContainer = styled.div`
  background-color: var(--color-mono-100);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3.25rem;
  height: 3.25rem;
`;

export const SparklesIcon = styled(FontAwesomeIcon)`
  font-size: var(--fontSizes-xl);
  line-height: var(--lineHeights-xl);
  font-weight: var(--fontWeights-semi);
`;

export const MagnifyingGlassIcon = styled(FontAwesomeIcon)`
  font-size: var(--fontSizes-normal);
  line-height: var(--lineHeights-normal);
  font-weight: var(--fontWeights-semi);
`;

export const CFXContainer = styled(Flexbox)`
  margin-top: 1.5rem;
`;
